import React, { Component } from 'react';
import { connect } from 'shalala';

import { Badge } from 'react-bootstrap';
import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';

class ShoppingHistoryList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selected: [],
    };
  }

  get columns() {
    return [
      {
        key: 'updated_at',
        title: 'Fecha',
        dataIndex: 'updated_at',
      },
      {
        key: 'descripcion',
        title: 'Paquete',
        dataIndex: 'descripcion',
      },
      {
        key: 'monto',
        title: 'Monto',
        dataIndex: 'monto',
      },
      {
        key: 'hits',
        title: 'Hits',
        dataIndex: 'hits',
        render: (item) => {
          return <span>{item.hits === -1 ? 'Hits ilimitados' : item.hits}</span>;
        },
      },
      {
        key: 'licencia',
        title: 'Licencia',
        dataIndex: 'licencia',
        render: this.renderLicencia,
      },
      {
        key: 'forma_pago',
        title: 'Forma Pago',
        dataIndex: 'forma_pago',
        render: this.renderFormaPago,
      },
      {
        key: 'factura',
        title: 'Factura',
        dataIndex: 'factura',
        render: this.renderFactura,
      },
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        className: 'text-center',
        render: this.renderStatus,
      },
    ];
  }

  renderFactura = (item) => {
    const { cfdi_uuid } = item;

    let text = cfdi_uuid ? 'Emitida' : 'No emitida';

    return <span>{text}</span>;
  };

  renderLicencia = (item) => {
    const { licencia } = item;

    let text = '';

    switch (licencia) {
      case 'y':
        text = 'Anual';
        break;

      case 'm':
        text = 'Mensual';
        break;

      default:
        break;
    }

    return <span>{text}</span>;
  };

  renderStatus = (item) => {
    const status = Number(item.status);

    let text = '';
    let variant = '';

    switch (status) {
      case 1:
        text = 'Pago exitoso';
        variant = 'success';
        break;

      case -1:
        text = 'Pago rechazado';
        variant = 'danger';
        break;

      case 0:
        text = 'Pago pendiente';
        variant = 'warning';
        break;

      case 2:
        text = 'Procesando';
        variant = 'warning';
        break;

      case 3:
        text = 'Autenticando';
        variant = 'warning';
        break;

      case 4:
        text = 'Reembolso';
        variant = 'warning';
        break;

      default:
        break;
    }

    return <Badge variant={variant}>{text}</Badge>;
  };

  renderFormaPago = (item) => {
    const { gateway, forma_pago, metadata } = item;
    const { payment = {} } = metadata;
    const { brand, last4 } = payment;

    let text = '';

    switch (gateway) {
      case 'stripe':
        text = brand && last4 && `${brand} ${last4}`;
        break;

      case 'transfer':
        text = forma_pago;
        break;

      default:
        break;
    }

    return <span className="text-upper">{text}</span>;
  };

  componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  paginate(page = 1) {
    this.props.paginate({
      page,
    });
  }

  handleOnPageChange = (page) => {
    this.paginate(page);
  };

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
    };
  }

  render() {
    const { columns } = this.state;
    const { data, busy } = this.props;
    const { onRowClick } = this.props;

    return (
      <Table
        loading={busy}
        columns={columns}
        rowKey={'id'}
        data={data}
        pagination={this.getPaginationConfig()}
        onRowClick={onRowClick}
      ></Table>
    );
  }
}

const mapState = (state) => {
  return state.cuenta.historial_compra.list;
};

const mapActions = (actions) => {
  return {
    paginate: actions.cuenta.historial_compra.list.paginate,
  };
};

export default connect(useStore, mapState, mapActions)(ShoppingHistoryList);
